module.exports = __webpack_public_path__ + "img/icon-close.b0c19aa0.svg";